import React, { FC, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MotifVerticalNavigationSubmenu } from '@ey-xd/motif-react';

import {
    VerticalNavigation,
    VerticalNavigationContent,
    VerticalNavigationMenuItem,
    VerticalNavigationMenu
} from 'common/components';

import './SideNav.scss';
import { useRolesAndAccess } from 'common/providers/AccessProvider';

const SideNav: FC = () => {
    /**const [selectedRoute, setSelectedRoute] = useState(MENU_ROUTES[0].path);*/
    const [selectedRoute, setSelectedRoute] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const { featuresHierarchy } = useRolesAndAccess();

    useEffect(() => {
        setSelectedRoute(location.pathname);
    }, [location.pathname]);

    return (
        <VerticalNavigation className="sideNav-main">
            <VerticalNavigationContent className="sideNav-content">
                <VerticalNavigationMenu>
                    {featuresHierarchy.map((ele) => {
                        if (ele?.subRoutes && ele?.subRoutes.length > 0) {
                            return (
                                <MotifVerticalNavigationSubmenu
                                    key={ele.path}
                                    icons={{ title: <img src={ele.icon} /> }}
                                    selected={selectedRoute.startsWith(ele.path)}
                                    title={ele.label}
                                    className={`menu-item ${
                                        selectedRoute.startsWith(ele.path)
                                            ? 'menu-item-active'
                                            : 'menu-item-default'
                                    }`}>
                                    {ele.subRoutes.map((rout) => {
                                        return (
                                            <VerticalNavigationMenuItem
                                                key={rout.path}
                                                label={rout.label}
                                                onClick={() => {
                                                    setSelectedRoute(rout.path);
                                                    navigate(rout.path);
                                                }}
                                                selected={selectedRoute === rout.path}
                                                className={`menu-item ${
                                                    selectedRoute === rout.path
                                                        ? 'menu-item-active'
                                                        : 'menu-item-default'
                                                }`}>
                                                {rout.label}
                                            </VerticalNavigationMenuItem>
                                        );
                                    })}
                                </MotifVerticalNavigationSubmenu>
                            );
                        }
                        return (
                            <VerticalNavigationMenuItem
                                icon={<img src={ele.icon} />}
                                key={ele.path}
                                label={ele.label}
                                onClick={() => {
                                    setSelectedRoute(ele.path);
                                    navigate(ele.path);
                                }}
                                selected={location.pathname === ele.path}
                                className={`menu-item ${
                                    location.pathname === ele.path
                                        ? 'menu-item-active'
                                        : 'menu-item-default'
                                }`}>
                                {ele.label}
                            </VerticalNavigationMenuItem>
                        );
                    })}
                </VerticalNavigationMenu>
            </VerticalNavigationContent>
        </VerticalNavigation>
    );
};

export default SideNav;
/**
 *   <VerticalNavigation className="sideNav-main">
            <VerticalNavigationContent className="sideNav-content">
                <VerticalNavigationMenu>
                    {featuresHierarchy.map((feature: Features) => {
                        if (componentsRegistry[feature.featureKey]) {
                            const featureData = componentsRegistry[feature.featureKey] ?? {};
                            if (feature.subFeatures.length > 0) {
                                return (
                                    <MotifVerticalNavigationSubmenu
                                        key={featureData.path}
                                        icons={{ title: <img src={featureData.icon} /> }}
                                        selected={selectedRoute.startsWith(featureData.path)}
                                        title={featureData.label}
                                        className={`menu-item ${
                                            selectedRoute.startsWith(featureData.path)
                                                ? 'menu-item-active'
                                                : 'menu-item-default'
                                        }`}>
                                        {feature.subFeatures.map((subFeature: Features) => {
                                            if (featureData.subRoutes[subFeature.featureKey]) {
                                                const subFeatureData =
                                                    featureData.subRoutes[subFeature.featureKey];
                                                return (
                                                    <VerticalNavigationMenuItem
                                                        key={subFeatureData.path}
                                                        label={subFeatureData.label}
                                                        onClick={() => {
                                                            setSelectedRoute(subFeatureData.path);
                                                            navigate(subFeatureData.path);
                                                        }}
                                                        selected={
                                                            selectedRoute === subFeatureData.path
                                                        }
                                                        className={`menu-item ${
                                                            selectedRoute === subFeatureData.path
                                                                ? 'menu-item-active'
                                                                : 'menu-item-default'
                                                        }`}>
                                                        {subFeatureData.label}
                                                    </VerticalNavigationMenuItem>
                                                );
                                            }
                                            return null;
                                        })}
                                    </MotifVerticalNavigationSubmenu>
                                );
                            }
                            return (
                                <VerticalNavigationMenuItem
                                    icon={<img src={featureData.icon} />}
                                    key={featureData.path}
                                    label={featureData.label}
                                    onClick={() => {
                                        setSelectedRoute(featureData.path);
                                        navigate(featureData.path);
                                    }}
                                    selected={location.pathname === featureData.path}
                                    className={`menu-item ${
                                        location.pathname === featureData.path
                                            ? 'menu-item-active'
                                            : 'menu-item-default'
                                    }`}>
                                    {featureData.label}
                                </VerticalNavigationMenuItem>
                            );
                        }
                        return null;
                    })}
                </VerticalNavigationMenu>
            </VerticalNavigationContent>
        </VerticalNavigation>
 */
